import { Routes, Route, Navigate } from "react-router-dom";
import { SuperAdminSidebar } from "../../Sidebar/superadmin-sidebar";
import DashboardOverview from "../Superadmindashboard/DashboardOverview";
import SchoolsManagement from "../Superadmindashboard/SchoolsManagement";
import SchoolDetails from "../Superadmindashboard/SchoolDetails";
import SchoolInventoryActivity from "../Superadmindashboard/SchoolInventoryActivity";
import SchoolSettingsPageNew from "../../pages/SchoolSettingsPageNew";
import SuperSchooladminManagement from "../Superadmindashboard/SuperSchooladminManagement";
import LogsViewer from "../Superadmindashboard/LogsViewer";
import SchoolLogsDetail from "../Superadmindashboard/SchoolLogsDetail";
import BusLocationTracking from "../Superadmindashboard/BusLocationTracking";
import VehicleTrackingDetails from "../Superadmindashboard/VehicleTrackingDetails";
import AppVersionConfig from "../Superadmindashboard/AppVersionConfig";
import PublicLeads from "../Superadmindashboard/PublicLeads";
import PageVisitAnalytics from "../Superadmindashboard/PageVisitAnalytics";
import ApiHitsAnalytics from "../Superadmindashboard/ApiHitsAnalytics";
import DemoBookings from "../Superadmindashboard/DemoBookings";
import BlogManagement from "../Superadmindashboard/BlogManagement";
import BillingOverview from "../Superadmindashboard/Billing/BillingOverview";
import PlansManagement from "../Superadmindashboard/Billing/PlansManagement";
import BillingClients from "../Superadmindashboard/Billing/BillingClients";
import SchoolBillingDetail from "../Superadmindashboard/Billing/SchoolBillingDetail";
import SchoolSubscriptionHistory from "../Superadmindashboard/Billing/SchoolSubscriptionHistory";
import SchoolPaymentsHistory from "../Superadmindashboard/Billing/SchoolPaymentsHistory";
import SchoolInvoiceHistory from "../Superadmindashboard/Billing/SchoolInvoiceHistory";
import SchoolAuditLog from "../Superadmindashboard/Billing/SchoolAuditLog";

export default function SuperAdminDashboardRouter() {
  return (
    <Routes>
      <Route path="/" element={<SuperAdminSidebar />}>
        <Route index element={<Navigate to="/dashboard/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardOverview />} />
        <Route path="schools" element={<SchoolsManagement />} />
        <Route path="schools/:schoolId" element={<SchoolDetails />} />
        <Route path="schools/:schoolId/inventory" element={<SchoolInventoryActivity />} />
        <Route path="schools/:schoolId/settings" element={<SchoolSettingsPageNew />} />
        <Route path="schools/:schoolId/billing" element={<SchoolBillingDetail />} />
        <Route path="schools/:schoolId/billing/subscriptions" element={<SchoolSubscriptionHistory />} />
        <Route path="schools/:schoolId/billing/payments" element={<SchoolPaymentsHistory />} />
        <Route path="schools/:schoolId/billing/invoices" element={<SchoolInvoiceHistory />} />
        <Route path="schools/:schoolId/billing/audit" element={<SchoolAuditLog />} />
        <Route path="billing" element={<BillingOverview />} />
        <Route path="billing/plans" element={<PlansManagement />} />
        <Route path="billing/clients" element={<BillingClients />} />
        <Route path="super-school-admins" element={<SuperSchooladminManagement />} />
        <Route path="app-version" element={<AppVersionConfig />} />
        <Route path="public-leads" element={<PublicLeads />} />
        <Route path="page-analytics" element={<PageVisitAnalytics />} />
        <Route path="api-analytics" element={<ApiHitsAnalytics />} />
        <Route path="demo-bookings" element={<DemoBookings />} />
        <Route path="blog-management" element={<BlogManagement />} />
        <Route path="system-logs" element={<LogsViewer />} />
        <Route path="system-logs/school/:schoolId" element={<SchoolLogsDetail />} />
        <Route path="bus-tracking" element={<BusLocationTracking />} />
        <Route path="bus-tracking/vehicle/:vehicleId" element={<VehicleTrackingDetails />} />
        <Route path="*" element={<Navigate to="/dashboard/dashboard" replace />} />
      </Route>
    </Routes>
  );
}

